import { createReducer } from '@reduxjs/toolkit';
import { getFromLocalStorage, setToLocalStorage } from '../../global/helpers';
import { AppState } from '../../global/types';
import { LoginState } from './types';
import * as actions from './actions';

const initialState: LoginState = {
  error: null,
  loading: false,
  accessToken: getFromLocalStorage('accessToken') || null,
  refreshToken: getFromLocalStorage('refreshToken') || null,
  errorMessage: null,
  userData: {
    data: null,
    error: null,
    loading: false,
  },
  authWhatsappNumber: '',
  submited: false,
};

const reducer = createReducer(initialState, {
  [actions.getValidationCode.ERROR]: (state, action) => {
    if (action.payload.response.data.error === 'not allowed for role') {
      state.errorMessage = action.payload.response.data.error;
      state.error = action.payload.message;
    }
    state.submited = false;
    state.loading = false;
  },
  [actions.getValidationCode.SUCCESS]: (state) => {
    state.submited = true;
    state.error = null;
  },
  [actions.auth.REQUEST]: (state) => {
    state.loading = true;
  },
  [actions.auth.ERROR]: (state, action) => {
    state.errorMessage = action.payload.response.data.error;
    state.error = action.payload.message;
    state.loading = false;
  },
  [actions.auth.SUCCESS]: (state, action) => {
    state.accessToken = action.payload.access_token;
    state.refreshToken = action.payload.refresh_token;
    state.loading = false;
  },
  [actions.logout.type]: (state) => {
    state.accessToken = null;
    state.refreshToken = null;
    setToLocalStorage('education', false);
  },
  [actions.loginClearError.type]: (state) => {
    state.error = null;
  },

  [actions.getUserInfo.REQUEST]: (state) => {
    state.userData.loading = true;
  },
  [actions.getUserInfo.ERROR]: (state, action) => {
    state.userData.error = action.payload;
    state.userData.loading = false;
  },
  [actions.getUserInfo.SUCCESS]: (state, action) => {
    state.userData.data = action.payload;
    state.userData.loading = false;
  },
  [actions.getWhatsappAuthNumber.SUCCESS]: (state, action) => {
    state.authWhatsappNumber = action.payload.phone;
  },
  [actions.clearErrorMessage.type]: (state) => {
    state.submited = false;
    state.errorMessage = null;
  },
});

const error = (state: AppState) => state.loginReducer.error;
const loading = (state: AppState) => state.loginReducer.loading;
const accessToken = (state: AppState) => state.loginReducer.accessToken;
const refreshToken = (state: AppState) => state.loginReducer.refreshToken;
const errorMessage = (state: AppState) => state.loginReducer.errorMessage;
const userData = (state: AppState) => state.loginReducer.userData.data;
const whatsAppAuthNumber = (state: AppState) =>
  state.loginReducer.authWhatsappNumber;
const clearErrorMessage = (state: AppState) => state.loginReducer.errorMessage;
const wasSubmitted = (state: AppState) => state.loginReducer.submited;

const selectors = {
  errorMessage,
  error,
  loading,
  accessToken,
  refreshToken,
  userData,
  whatsAppAuthNumber,
  clearErrorMessage,
  wasSubmitted,
};

export { selectors };
export default reducer;
